/* eslint-disable react-hooks/exhaustive-deps */
import { fetchPhpEigth } from "api";
import Breadcrumcomponent from "components/BreadCrumbMex/BreadCrumb";
import BreadCurmbPasos from "components/BreadCrumbMex/BreadCrumbTipo2";
import SimpleContainer from "components/InputsMex/containers/SimpleContainer";
import { DropDown, DropDownDate, TextInput } from "components/InputsMex/inputs";
import Page from "components/Page";
import EmisionFooterBarButtons from "components/Polizas/EmisionFooterBarButtons";
import { ambienteAplicacion, urlEmisionPoliza } from "constants/urls";
import { useNavbarContext } from "contexts/NavbarContext";
import withValidarRecuperar from "HOC/withValidarRecuperar";
import usePasosEmision from "hooks/usePasosEmision";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { PASOS_BREADCRUMBS, PRODUCTOS } from "utils/constants";
import { processRulesBD } from "utils/funciones";
import Loading from "wrappers/Loading";
import "./styles.scss";
import useCustomToast from "hooks/useCustomToasts";

const ConductorAuto = ({ history, qParams }) => {
  useNavbarContext(PRODUCTOS.APINDIVIDUAL);
  const methods = useForm({
    mode: "onChange",
  });

  const { addWarningToast, addSuccessToast } = useCustomToast();

  const { handleSubmit, reset } = methods;
  const [loading, setLoading] = useState(true);
  const [catalogo, setCatalogo] = useState({});
  const { verificarPolizaCompletada } = usePasosEmision();
  //Auto

  const [routes, setRoutes] = useState({});
  const { idPoliza, codProducto } = qParams;
  const [validacionNombres, setValidacionNombre] = useState("");
  const [valEdadesConductores, setValEdadesConductores] = useState({});

  const requiredMessage = "Este campo es obligatorio";

  const getData = async () => {
    setLoading(true);

    const body = {
      datosCotizador: {
        ambiente: ambienteAplicacion,
        prodCodigo: "AUTO",
        cotPasoCodigo: "listarDatosRiesgo",
        polCodigo: idPoliza,
      },
    };
    const res = await fetchPhpEigth(urlEmisionPoliza, body);
    if (res.transaccion) {
      const catalogoTmp = res.catalogo.listarDatosRiesgo;
      const sexo = res.catalogo.listarDatosRiesgo.sexo.map((item) => ({
        label: item.label,
        value: item,
      }));
      const ecivil = res.catalogo.listarDatosRiesgo.estadosCiviles.map((item) => ({
        label: item.label,
        value: item,
      }));
      catalogoTmp.sexo = sexo;
      catalogoTmp.estadosCiviles = ecivil;
      setCatalogo(catalogoTmp);

      const rulesNombre = catalogoTmp?.validaciones?.filter(
        (item) => item.id === "nombres"
      );
      setValidacionNombre(processRulesBD(rulesNombre[0]?.rules, {}));
      verificarPolizaCompletada(catalogoTmp?.pasosRedireccionamiento);
      setRoutes(catalogoTmp?.pasosRedireccionamiento);

      const validacionesEdad = catalogoTmp?.validaciones?.filter(
        (item) => item.id === "edadConductores"
      );
      setValEdadesConductores(validacionesEdad[0]);

      const usoFromBase = catalogoTmp?.validaciones?.filter(
        (item) => item.id === "usoDefaultValue"
      );
      let tipoUso = usoFromBase?.[0]?.defaultValue || "USO PERSONAL";
      if (catalogoTmp.datosRiesgo) {
        const { datosRiesgo } = catalogoTmp;
        if (datosRiesgo.tipoUso && datosRiesgo.tipoUso !== "") {
          tipoUso = datosRiesgo.tipoUso;
        }
        reset({
          datosRiesgo: {
            ...datosRiesgo,
            tipoUso,
          },
        });
      } else {
        //Agregado para cargar el valor Default del tipo de uso
        reset({
          datosRiesgo: {
            tipoUso,
          },
        });
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const onSubmit = async (data) => {
    const formData = { ...data };
    await guardarInformacion(data.datosRiesgo, false, formData);
  };

  const validarConductores = async (data) => {
    if (!data.sexo) {
      data.sexo = {};
    }
    if (!data.estadoCivil) {
      data.estadoCivil = {};
    }
    return data;
  };

  const guardarInformacion = async (data, guardarDatos = true, formData) => {
    setLoading(true);

    const conductor1 = await validarConductores(data.conductor1);

    let Data1 = {
      guardarDatos,
      datosCotizador: {
        ambiente: ambienteAplicacion,
        prodCodigo: "AUTO",
        cotPasoCodigo: "guardarDatosRiesgo",
        pasoRiesgo: "datosConductor",
      },
      items: {
        polCodigo: idPoliza,
        datosConductor: {
          conductor1: conductor1,
        },
      },
    };
    const res = await fetchPhpEigth(urlEmisionPoliza, Data1);
    if (res.transaccion) {
      if (guardarDatos === false) {
        //const route = routes.find((e) => e.codigo === "conductorPrincipal");
        //return history.push(`${route.goTo}`);
        return history.push(`facturacion/tipo-persona?idPoliza=${idPoliza}&ramo=AUTO`)
      }
      addSuccessToast("Se ha guardado la información de forma correcta");
    } else {
      
      addWarningToast(
        res.errorDescripcion
          ? res.errorDescripcion
          : "Ha ocurrido un problema al momento de guardar la información del riesgo"
      );
    }

    setLoading(false);
    methods.reset({ ...formData });
  };

  const onClickAtras = () => {
    const route = routes.find((e) => e.codigo === "conductorPrincipal");
    history.push(`${route.goBack}`);
  };

  const onGuardar = async () => {
    const data = methods.getValues();
    const formData = { ...data };
    await guardarInformacion(data.datosRiesgo, true, formData);
  };

  const onSubmitError = (errors) => {};
  const handleUpperInput = (value) => {
    return value.toUpperCase();
  };

  return (
    <Loading loading={loading}>
      <div className='cr-content'>
        <Page>
          <Breadcrumcomponent
            {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasos[8].breadCrumb}
          />

          <BreadCurmbPasos {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasos[8]} />

          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit, onSubmitError)}>
              <div className='row justify-content-center'>
                <div className='col-11 col-md-11 col-md-10 card-login-mex'>
                  <h2
                    className='font-mex mt-4 mb-3 text-mex text-center'
                    style={{ fontSize: "26px" }}>
                    Datos del conductor principal
                  </h2>

                  <div className='row'>
                    <div className='col-12 ml-5'>
                      <div className='d-flex flex-row'></div>
                    </div>

                    <div className='col-12'>
                      <div className='row justify-content-center'>
                        <div className='col-md-11 col-lg-10'>
                          <div className='row justify-content-between'></div>
                          <div className='row justify-content-between conductor-border'>
                            <div className='form-group col-md-6 col-lg-5 '>
                              <SimpleContainer
                                label={"Nombres"}
                                name='datosRiesgo.conductor1.nombres'>
                                <TextInput
                                  inputProps={{
                                    name: "datosRiesgo.conductor1.nombres",
                                  }}
                                  rules={validacionNombres}
                                  onChangeBn={handleUpperInput}
                                />
                              </SimpleContainer>
                            </div>
                            <div className='form-group col-md-6 col-lg-5 '>
                              <SimpleContainer
                                label={"Apellido Paterno"}
                                name='datosRiesgo.conductor1.apellidoPaterno'>
                                <TextInput
                                  inputProps={{
                                    name: "datosRiesgo.conductor1.apellidoPaterno",
                                    //isNumberInt: true,
                                    //disabled: true,
                                  }}
                                  rules={validacionNombres}
                                  onChangeBn={handleUpperInput}
                                />
                              </SimpleContainer>
                            </div>
                            <div className='form-group col-md-6 col-lg-5 '>
                              <SimpleContainer
                                label={"Apellido Materno"}
                                name='datosRiesgo.conductor1.apellidoMaterno'>
                                <TextInput
                                  inputProps={{
                                    name: "datosRiesgo.conductor1.apellidoMaterno",
                                    //isNumberInt: true,
                                    //disabled: true,
                                  }}
                                  rules={validacionNombres}
                                  onChangeBn={handleUpperInput}
                                />
                              </SimpleContainer>
                            </div>
                            <div className='form-group col-md-6 col-lg-5 '>
                              <SimpleContainer
                                label='Sexo'
                                name='datosRiesgo.conductor1.sexo'>
                                <DropDown
                                  rules={{
                                    required: requiredMessage,
                                  }}
                                  name='datosRiesgo.conductor1.sexo'
                                  options={catalogo.sexo}
                                />
                              </SimpleContainer>
                            </div>
                            <div className='form-group col-md-6 col-lg-5 '>                              
                              <SimpleContainer
                                label={"Fecha nacimiento"}
                                name='datosRiesgo.conductor1.fechaNacimiento'>
                                <DropDownDate
                                  name='datosRiesgo.conductor1.fechaNacimiento'
                                  rules={{
                                    required: requiredMessage,
                                    validate: (value) => {
                                      const valueMoment = moment(value, "yyy-MM-DD");
                                      const fechaMinima = moment().subtract(
                                        valEdadesConductores.edadMinima,
                                        "years"
                                      );
                                      const fechaMaxima = moment().subtract(
                                        valEdadesConductores.edadMaxima,
                                        "years"
                                      );
                                      if (valueMoment.isBefore(fechaMaxima)) {
                                        return (
                                          "La edad máxima es de " +
                                          valEdadesConductores.edadMaxima +
                                          " años cumplidos"
                                        );
                                      }
                                      if (valueMoment.isAfter(fechaMinima)) {
                                        return (
                                          "La edad mínima es de " +
                                          valEdadesConductores.edadMinima +
                                          " años cumplidos"
                                        );
                                      }
                                      return true;
                                    },
                                  }}
                                  {...{
                                    maxDate: moment()
                                      .subtract(
                                        valEdadesConductores.edadMinima - 1,
                                        "years"
                                      )
                                      .toDate(),
                                    minDate: moment()
                                      .subtract(
                                        valEdadesConductores.edadMaxima + 1,
                                        "years"
                                      )
                                      .toDate(),
                                  }}
                                />
                              </SimpleContainer>
                            </div>
                            <div className='form-group col-md-6 col-lg-5 '>
                              <SimpleContainer
                                label={"Estado civil"}
                                name='datosRiesgo.conductor1.estadoCivil'>
                                <DropDown
                                  rules={{
                                    required: requiredMessage,
                                  }}
                                  name='datosRiesgo.conductor1.estadoCivil'
                                  options={catalogo.estadosCiviles}
                                />
                              </SimpleContainer>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </FormProvider>
        </Page>
        <EmisionFooterBarButtons
          onClickAtras={onClickAtras}
          onClickGuardar={onGuardar}
          onClickContinuar={methods.handleSubmit(onSubmit, onSubmitError)}
        />
      </div>
    </Loading>
  );
};

export default withValidarRecuperar(ConductorAuto);